import { useRef } from "react";
import { XChatDisabledPreferenceValue } from "types";
import { useSeller, useUser } from "../hooks/useAccount";
import { useResource } from "../hooks/useResource";
/* eslint-disable import/no-unassigned-import */
import "./fullstory";
import "./googleTagManager";
import { loadSnippets } from "./index";
import "./pusher";
import "./sentry";
import "./xchat";

/* eslint-enable import/no-unassigned-import */

export const useSnippets = () => {
    const user = useUser();
    const seller = useSeller();
    const ref = useRef(false);
    const { data: xchatPreference, isLoading } = useResource<XChatDisabledPreferenceValue>([
        "preferences",
        "xchat",
        "enabled",
    ]);
    const isXchatEnabled = xchatPreference?.value ?? true;

    if (ref.current || isLoading) {
        return;
    }

    // Load registered third-party snippets
    // console.group(`Snippets initialization for ${user.name} ${user.name === seller.name ? "" : seller.name}`);
    loadSnippets(user, seller, isXchatEnabled);
    // console.groupEnd();
    ref.current = true;
};
